import { createElement as rc, useContext, useEffect, useState } from 'react';
import { fromTheme, View, webOnlyStyles, styled, GestureContext } from 'lib_ui-primitives';
import useSpaceConstrained from '../../../hooks/useSpaceConstrained';
import { globalConfig } from 'lib_ui-services';

// Todo: GL2025 - Remove this file

// subtract three from height for bottom border
let _Header = styled(View).attrs({ name: 'header' })`
    min-height: ${({ theme: { titleBar, mobile }, collapsed }) => (mobile && collapsed ? '0' : titleBar.height + 'px')};
    max-height: ${({ theme: { mobile }, collapsed }) => (mobile && collapsed ? '0' : '99999px')};
    display: flex;
    flex-basis: auto;
    flex-grow: 0;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    background-color: ${fromTheme('sideBar', 'backgroundColor')};
    border-bottom-color: ${fromTheme('titleBar', 'borderColor')};
    border-bottom-width: ${({ theme: { titleBar, mobile }, collapsed }) =>
        mobile && collapsed ? '0' : titleBar.bottomBorderWidth + 'px'};
    overflow: hidden;
`;
_Header.displayName = 'Header';

_Header = webOnlyStyles(_Header)`
    border-bottom-style: solid;
    transition: min-height 0.3s linear;
`;

const _p = { globalConfig };
/**
 * This will hold page title, buttons for navigation and profile, etc.
 * It will collapse if the app is space constrained or
 * a mobile user swipes up.
 * @param {object} props
 * @returns Main app header component
 */
export default function Header(props) {
    const [spaceConstrained] = useSpaceConstrained();
    const disableHeaderHiding = _p.globalConfig().disableHeaderHiding;
    const { onSwipeUp, onSwipeDown } = useContext(GestureContext);
    const [collapsed, setCollapsed] = useState(false);
    useEffect(() => {
        // prettier-ignore
        let unsubscribes = [
            onSwipeUp(() => !disableHeaderHiding && setCollapsed(true)),
            onSwipeDown(() => !disableHeaderHiding && setCollapsed(false))
        ];
        return () => unsubscribes.forEach(u => u());
    }, [onSwipeDown, onSwipeUp, disableHeaderHiding]);

    return rc(_Header, { collapsed: !disableHeaderHiding && (collapsed || spaceConstrained), ...props });
}

Header._private = _p;
